import { useRef } from 'react';

import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ExistedMetric from '../../components/TrackerDataTable/components/ExistedMetric';
import { createCustomMetric } from '../../sources/metrics';
import { createCustomMetric as queryKey, metrics } from '../queryKeyFactory';

/* eslint-disable no-useless-escape */
const getMetricNameFromError = (error) =>
  error.message.match(/Metric name: \"([\w\W\d]+)\" Severity: /)?.[1];

export const useCreateMetric = () => {
  const showExistedMetricDialog = useScreenModalV2(ExistedMetric);
  const search = useRef(null);
  const createMutation = useMutation(queryKey(), createCustomMetric, {
    successMessage: () => 'Custom metric created',
    refreshOptions: {
      queryKey: metrics.all(),
    },
    errorMessage: (error) => {
      const metricName = getMetricNameFromError(error);

      if (metricName) {
        return null;
      } else {
        return error.message;
      }
    },
    onError: (error) => {
      const metricName = getMetricNameFromError(error);

      if (metricName) {
        showExistedMetricDialog({
          name: metricName,
          onSearch: () => {
            search.current(metricName);
          },
        });
      }
    },
  });
  const handleAction = async ({ values, onSearch }) => {
    search.current = onSearch;
    await createMutation.mutateAsync(values);
  };
  return [handleAction, createMutation];
};
